import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Account from "@/pages/Account";
import TrackOrder from "@/pages/TrackOrder";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminOrders from "@/pages/admin/Orders";
import AdminOrderDetail from "@/pages/admin/OrderDetail";
import AdminCustomers from "@/pages/admin/Customers";
import AdminEmailLog from "@/pages/admin/EmailLog";

function StoreLayout({ children }) {
  return (
    <>
      <Header />
      <CartDrawer />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen text-white">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              {/* Storefront */}
              <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
              <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
              <Route path="/shop/:category" element={<StoreLayout><Shop /></StoreLayout>} />
              <Route path="/product/:slug" element={<StoreLayout><ProductDetail /></StoreLayout>} />
              <Route path="/checkout" element={<StoreLayout><Checkout /></StoreLayout>} />
              <Route path="/order/:id" element={<StoreLayout><OrderSuccess /></StoreLayout>} />
              <Route path="/account" element={<StoreLayout><Account /></StoreLayout>} />
              <Route path="/track" element={<StoreLayout><TrackOrder /></StoreLayout>} />

              {/* Admin */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="orders/:id" element={<AdminOrderDetail />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="email-log" element={<AdminEmailLog />} />
              </Route>
            </Routes>
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#110E1D",
                  color: "#F8F9FA",
                  border: "1px solid rgba(176,38,255,0.25)",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
